<script setup lang="ts">
import { downloadCSV } from "@/helper/csv_export";
import { downloadPDF } from "@/helper/pdf_export";

import { useGlobalStore } from "@/store/global";
import { appButtonClick } from "@/utils/analytics";

const globalStore = useGlobalStore();
const props = defineProps({
  containers: {
    type: Array as () => any[],
    required: true,
    default: () => []
  },
  fileName: {
    type: String,
    required: true,
    default: "Print_Containers"
  },
  headerLabel: {
    type: Object as () => any,
    required: true,
    default: () => ({})
  },
  isDisabled: {
    type: Boolean,
    required: true,
    default: false
  },
  terminalOneStreamCode: {
    type: String,
    required: true,
    default: ""
  },
  analyticsTerminalDetails: {
    type: Object as () => Record<string, any>,
    required: true,
    default: () => ({})
  }
});

const labels = {
  csv: globalStore.sitecoreData.action_button.export_csv,
  print: globalStore.sitecoreData.action_button.print
};

// Export function to be called on button click
const exportToCSV = (): void => {
  appButtonClick("CSV Download", props.analyticsTerminalDetails.tabName, props.terminalOneStreamCode, {
    resultsCount: props.containers.length,
    ...props.analyticsTerminalDetails
  });
  const filename = `${props.fileName}_${new Date().toISOString().split("T")[0]}.csv`;
  downloadCSV(props.containers, props.headerLabel, filename, props.fileName);
};

// Generating pdf and printinng all the searched container data
const exportToPDF = (): void => {
  appButtonClick("PDF Download", props.analyticsTerminalDetails.tabName, props.terminalOneStreamCode, {
    resultsCount: props.containers.length,
    ...props.analyticsTerminalDetails
  });
  downloadPDF(props.containers, props.headerLabel);
};
</script>

<template>
  <div class="action-buttons">
    <mc-tooltip>
      <mc-button
        slot="trigger"
        :disabled="isDisabled"
        fit="medium"
        variant="outlined"
        appearance="neutral"
        hiddenlabel
        @click="exportToCSV()"
      >
        <span slot="icon">
          <mc-icon size="24" icon="file-csv"></mc-icon>
        </span>
      </mc-button>
      <span>{{ labels.csv }}</span>
    </mc-tooltip>
    <mc-tooltip>
      <mc-button
        slot="trigger"
        :disabled="isDisabled"
        fit="medium"
        variant="outlined"
        appearance="neutral"
        hiddenlabel
        @click="exportToPDF()"
      >
        <span slot="icon">
          <mc-icon size="24" icon="printer"></mc-icon>
        </span>
      </mc-button>
      <span>{{ labels.print }}</span>
    </mc-tooltip>
  </div>
</template>
